import { render, staticRenderFns } from "./link-properties-step.vue?vue&type=template&id=f2b173f6"
import script from "./link-properties-step.vue?vue&type=script&lang=js"
export * from "./link-properties-step.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports